import herotote from "../img/hero-tote.jpeg";
import heropartybag from "../img/hero-partybag.jpeg";
import herohandbag from "../img/hero-handbag.jpeg";
import { Link } from "react-router-dom";

const TextLayoverImg = ({to}) => {

    return (
        <section class="hero">
            <div class="hero-overlay"></div>

            <div class="hero-content">
                <span class="hero-subtitle">Since 1960</span>
                <h1 class="hero-title animate delay-1">Bella Vega</h1>

                <p class="hero-text animate delay-2">
                     Carry Your Grace. Own Your Style.
                 </p>
                 <Link to={to}>
                        <a href="#" class="hero-btn delay-3">EXPLORE →</a>
                 </Link>
            </div>

            <div class="hero-images">
                <img src={herotote} class="img img-1" />
                <img src={heropartybag} class="img img-2" />
                <img src={herohandbag} class="img img-3" />
            </div>
        </section>
    );
}

export default TextLayoverImg;